enum EmailStatus {
    BOUNCED = 'BOUNCED',
    CONFIRMED = 'CONFIRMED',
    NEW = 'NEW',
}

export default EmailStatus;
